var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.6 10.108a.6.6 0 1 0-1.2 0v11.444a.6.6 0 1 0 1.2 0zM17 24.608a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.95 3.405a1.2 1.2 0 0 1 2.1 0l13.297 24.028a1.2 1.2 0 0 1-1.05 1.781H2.702a1.2 1.2 0 0 1-1.05-1.78zm1.05.58 13.297 24.03H2.702z",
  clipRule: "evenodd"
})));
export { SvgWarning as ReactComponent };